import { BundleItemType } from 'generated/graphql';

import { AllPrograms, SubscriptionBundle } from '../../common/bundle.types';

const getProgramIdsFromBundles = (bundles: SubscriptionBundle[]): Set<number> =>
  new Set(
    bundles
      .flatMap((b) => b.items)
      .filter((item) => item.itemType === BundleItemType.Program)
      .map((item) => item.itemId)
      .filter((id): id is number => id !== undefined),
  );

export const toNewlyAddedDraftProgramNames = (params: {
  currentBundles: SubscriptionBundle[];
  initialBundles: SubscriptionBundle[];
  subscriptionPrograms: AllPrograms;
}): string[] => {
  const currentProgramIds = getProgramIdsFromBundles(params.currentBundles);
  const initialProgramIds = getProgramIdsFromBundles(params.initialBundles);

  const newlyAddedIds = [...currentProgramIds].filter(
    (id) => !initialProgramIds.has(id),
  );

  return params.subscriptionPrograms
    .filter((p) => newlyAddedIds.includes(p.id))
    .filter((p) => !p.isPublished)
    .map((p) => p.name);
};
